module.exports = __webpack_public_path__ + "img/com51.6e5eb742.png";